import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

import { navyBlue } from "@/angelouCE/utils/constants";

const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { md, sm },
} = constants.breakpoints;
const circular = typographyStyles.fontFamily.circular;
const { heading3Obj } = typographyStyles;

const greyDark = constants.colors.ui.neutral[600];
const newselaBlue = constants.colors.brand.blue[500];

export const containerCss = {
  padding: "16px",

  [mediaQuery.downTo(sm)]: {
    padding: "16px 40px",
  },

  [mediaQuery.downTo(md)]: {
    padding: "16px 24px",
  },
};

export const titleCss = {
  ...heading3Obj,
  ...circular,
  color: greyDark,
  margin: 0,
  fontWeight: "bold",
};

export const walledTeacherToastCSS = {
  Icon: {
    root: {
      paddingTop: "0px",
      width: "24px",
      height: "24px",
      circle: {
        fill: newselaBlue,
        stroke: newselaBlue,
      },
      path: {
        fill: "white",
        stroke: "white",
      },
    },
  },
  root: {
    boxShadow: "none",
    color: navyBlue,
    fontSize: "14px",
    fontWeight: "400",
    marginTop: "30px",
    marginBottom: "16px",
    "> div": {
      padding: "16px",
      background: constants.colors.brand.blue[25],
    },
    p: {
      margin: "0px",
    },
    a: {
      color: "inherit",
    },
  },
};
